export default "https://assets.egbcdn.net/assets/packs/_/videos/lootbox/video-default-3563c57d2f2bab382d551abbfd8b45c8.ogv";